// SidebarIcons.jsx
import React from "react";
import PropTypes from "prop-types";
import { FiX } from "react-icons/fi";

const SidebarIcons = ({ icons, onClose }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "12px",
        left: "12px",
        height: "280px",
        width: "80px",
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "15px 0",
        zIndex: 9999,
        borderRadius: "29px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        backdropFilter: "blur(4px)",
        overflow: "hidden",
      }}
    >
      {/* ICÔNE DE FERMETURE */}
      {onClose && (
        <div
          style={{
            position: "absolute",
            top: "8px",
            right: "8px",
            width: "24px",
            height: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "50%",
            transition: "background 0.2s, transform 0.2s",
            background: "#f2f2f2",
          }}
          onClick={onClose}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#f2f2f2";
            e.currentTarget.style.transform = "scale(1.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <FiX size={16} />
        </div>
      )}

      {/* ICÔNES PRINCIPALES */}
      {icons.map((item, idx) => (
        <div
          key={idx}
          style={{
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "12px",
            margin: "8px 0",
            transition: "background 0.3s, transform 0.2s",
          }}
          onClick={item.onClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#f2f2f2";
            e.currentTarget.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          {item.icon}
        </div>
      ))}
    </div>
  );
};

SidebarIcons.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.element.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
  onClose: PropTypes.func,
};

export default SidebarIcons;
